import { render, staticRenderFns } from "./selectCourse.vue?vue&type=template&id=f2830dde&scoped=true&"
import script from "./selectCourse.vue?vue&type=script&lang=js&"
export * from "./selectCourse.vue?vue&type=script&lang=js&"
import style0 from "./selectCourse.vue?vue&type=style&index=0&id=f2830dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2830dde",
  null
  
)

export default component.exports